import t from "../../locales/common.json";
import wave from "../../img/wave.svg";
import ContactForm from "../contact-form.marko";

<style/styles: any>
  .wave {
    background-image: var(--bg-image);
  }

  @media (width <=1024px) {
    .wave {
      background-image: none;
    }
  }
</style>

<define/InfoCard|input: { content: Marko.Body }|>
  <li class="text-primary mb-2 icon-wrapper flex align-items-center gap-2">
    <${input.content}/>
  </li>
</define>

<define/MailIcon>
  <svg
    class=(
      "text-accent"
      // title=t.cc.Contact.email.title
    )
    style={ width: "1.2em", height: "1.2em" }
    fill="none"
    viewBox="0 0 27 27"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="matrix(1.14 0 0 1.18 -2.76 -3.09)"
      clip-rule="evenodd"
      fill="currentColor"
      fill-rule="evenodd"
    >
      <path d="m3.61 7.29 0.134-0.15c0.49-0.512 1.22-0.768 2.19-0.768h16.6c0.913 0 1.61 0.223 2.1 0.668l0.0167 0.0167c0.1 0.0892 0.201 0.195 0.301 0.317 0 0.0114 0.0056 0.0224 0.0166 0.0334l0.0167 0.0167c0.368 0.456 0.551 1.1 0.551 1.94v9.45c-0.011 2-1.01 3.01-3.01 3.01h-16.6c-1.99-0.011-2.99-1.01-2.99-3.01v-9.45c0-0.902 0.223-1.59 0.668-2.07zm19.5 0.718c-0.167-0.0444-0.351-0.0614-0.551-0.0501h-16.6c-0.123-0.011-0.239-0.00568-0.351 0.0167l8.6 8.71zm-18.5 1.17c-0.011 0.0558-0.011 0.117 0 0.184v9.45c0 0.946 0.467 1.42 1.4 1.42h16.6c0.946 0 1.42-0.473 1.42-1.42v-9.43l-9.22 9c-0.167 0.156-0.356 0.234-0.567 0.234-0.223-0.011-0.412-0.0891-0.568-0.234z"/>
      <path d="m3.61 7.29c0.0224-0.0334 0.0501-0.0668 0.0835-0.1 0.0114-0.0224 0.0277-0.0391 0.0501-0.0501z"/>
    </g>
  </svg>
</define>

<define/PhoneIcon>
  <svg
    class=(
      "text-accent"
      // title=t.cc.Contact.phone.title
    )
    style={ width: "1.2em", height: "1.2em" }
    fill="none"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(-.485 -.393)"
      clip-path="url(#clip0_189_365)"
      fill="currentColor"
    >
      <path d="m13.8 7.31c1.17 0.202 2.25 0.757 3.1 1.61 0.851 0.851 1.41 1.92 1.61 3.1 0.0774 0.464 0.476 0.799 0.947 0.799 0.0609 0 0.115-7e-3 0.152-0.014 0.0024 0 0.0047 0 0.0071-0.0024 0.255-0.0422 0.478-0.18 0.626-0.394 0.148-0.211 0.204-0.464 0.159-0.715-0.267-1.57-1.01-3-2.14-4.14-1.14-1.14-2.57-1.88-4.14-2.14h-0.0024c-0.523-0.0867-1.02 0.267-1.1 0.788-0.082 0.525 0.27 1.02 0.788 1.11z"/>
      <path d="m19.7 15.4c-0.525-0.546-1.16-0.834-1.84-0.834-0.67 0-1.31 0.284-1.85 0.823l-1.33 1.33c-0.0328-0.0164-0.0656-0.0328-0.0961-0.0492l-0.068-0.0328c-0.143-0.0727-0.307-0.155-0.443-0.239-1.37-0.87-2.62-2.01-3.82-3.49-0.516-0.649-0.877-1.2-1.14-1.75 0.335-0.316 0.647-0.633 0.94-0.933 0.0656-0.0656 0.131-0.134 0.199-0.202 0.0656-0.068 0.134-0.136 0.202-0.204 0.558-0.558 0.853-1.2 0.851-1.87 0-0.663-0.295-1.31-0.851-1.86l-1.3-1.3c-0.075-0.075-0.15-0.15-0.223-0.225-0.0726-0.075-0.148-0.15-0.22-0.223l-0.103-0.105c-0.255-0.26-0.52-0.53-0.788-0.776-0.52-0.518-1.15-0.792-1.82-0.792-0.666 0-1.3 0.274-1.84 0.792-0.00235 0.00234-0.00469 0.00234-0.00469 0.00469l-1.62 1.62c-0.663 0.663-1.04 1.47-1.12 2.4v0.00234c-0.0867 1.1 0.112 2.26 0.628 3.66 0.78 2.11 1.95 4.06 3.68 6.15 2.11 2.52 4.65 4.51 7.54 5.91h0.0024c1.11 0.532 2.61 1.16 4.3 1.27h7e-3 0.0117c0.0961 0.0047 0.197 0.0094 0.302 0.0094 1.18 0 2.18-0.429 2.96-1.28l0.0117-0.0117c0.0094-0.0094 0.0164-0.0165 0.0235-0.0258 0.234-0.281 0.504-0.541 0.806-0.832 0.209-0.199 0.422-0.403 0.628-0.623 0.532-0.556 0.813-1.2 0.811-1.87-0.0024-0.67-0.288-1.31-0.827-1.85zm-0.258 6.53c-0.417 0.445-0.895 0.644-1.55 0.644-0.061 0-0.129-0.0047-0.199-0.0094-1.35-0.0867-2.63-0.621-3.59-1.08-2.65-1.28-4.98-3.1-6.91-5.41-1.58-1.91-2.65-3.68-3.35-5.59-0.422-1.13-0.581-2.01-0.516-2.84 0.0422-0.483 0.223-0.867 0.567-1.21l1.61-1.61c0.169-0.162 0.342-0.248 0.504-0.248 0.152 0 0.314 0.0844 0.485 0.251 0.00235 0.00235 0.00469 0.00469 0.00703 0.00704 0.279 0.262 0.551 0.539 0.839 0.83l0.00937 0.00938c0.138 0.143 0.298 0.307 0.459 0.464l1.29 1.29c0.377 0.377 0.377 0.642 0 1.02-0.136 0.136-0.274 0.274-0.41 0.415l-0.0961 0.0984c-0.363 0.368-0.705 0.715-1.08 1.05-0.00469 0.00469-0.0117 0.00938-0.0164 0.0164l-0.0234 0.0234c-0.396 0.396-0.504 0.87-0.319 1.4 0.00468 0.014 0.00937 0.0257 0.0141 0.0375 0.00234 7e-3 0.00469 0.014 0.00937 0.021 0.347 0.837 0.834 1.63 1.58 2.58 0 0.0024 0.00234 0.0024 0.00234 0.0047 1.33 1.64 2.74 2.92 4.29 3.91 0.204 0.129 0.415 0.237 0.612 0.335 0.145 0.0726 0.309 0.157 0.445 0.239 0.0094 7e-3 0.0188 0.0117 0.0282 0.0164l7e-3 0.0046c0.0141 0.0071 0.0281 0.0165 0.0445 0.0235 0.204 0.103 0.406 0.152 0.614 0.152 0.356 0 0.684-0.148 0.949-0.426l1.62-1.62c0.117-0.117 0.3-0.258 0.492-0.258 0.178 0 0.352 0.138 0.464 0.255l2.62 2.62c0.258 0.258 0.434 0.562-0.0211 1.04l-0.0023 0.0024c-0.143 0.155-0.295 0.302-0.457 0.459-0.0351 0.0328-0.0703 0.0679-0.105 0.103-0.328 0.307-0.642 0.612-0.938 0.963z"/>
      <path d="m24.5 11.5c-0.431-2.54-1.63-4.85-3.47-6.69-1.85-1.84-4.16-3.04-6.7-3.47-0.523-0.0867-1.02 0.267-1.1 0.788-0.0867 0.523 0.267 1.02 0.785 1.1 2.15 0.366 4.11 1.38 5.66 2.94 1.56 1.56 2.57 3.51 2.94 5.66 0.0773 0.464 0.476 0.799 0.947 0.799h7e-3c0.0586 0 0.108-7e-3 0.145-0.0141 0.0024 0 0.0047 0 7e-3 -0.0023 0.256-0.0422 0.478-0.18 0.626-0.394 0.15-0.209 0.206-0.462 0.162-0.712z"/>
    </g>
    <defs>
      <clipPath id="clip0_189_365">
        <rect
          transform="translate(.985 .894)"
          width="24"
          height="24"
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
</define>

<define/Email|input: { to: string }|>
  <a class="text-current underline" href=`mailto:${input.to}`>${input.to}</a>
</define>

<div
  class=[
    styles.wave,
    "fade pbs5 pbe1 bg-dark text-light bg-no-repeat bg-bottom bg-contain",
  ]
  style=[`--bg-image: url("${wave}")`, "background-origin: content-box"]
>
  <container width="medium">
    <heading-1 class="text-center font-bold mbe5">
      ${t.cc.Contact.header.header}
    </heading-1>
    <enclosed-section
      class="grid col-2-lg gap5 gap2-lg pb4 pi4 bg-dark"
      style=[
        "--shadow-color: var(--accent)",
        "margin-block-end: calc(var(--space-5) * 2)",
      ]
    >
      <div class="mbs0 flex flex-col gap0" style={ "max-width": "38ch" }>
        <h2 class="text2 font-semibold">${t.cc.Contact.header.cta}</h2>
        <p class="leading2">${t.cc.Contact.header.message}</p>

        <ul class="mb1 leading3 list-none">
          <InfoCard>
            <PhoneIcon/>
            <span>+39 346 2303221</span>
          </InfoCard>
          <InfoCard>
            <MailIcon/>
            <Email to="info@cubaconmigo.com"/>
          </InfoCard>
        </ul>
        <social-icons/>
      </div>

      <div>
        <ContactForm messageHeight=6/>
      </div>
    </enclosed-section>
  </container>
</div>
